import React from 'react';
function Toaster(props: React.PropsWithChildren<{}>) {
	const styleVars = getComputedStyle(document.querySelector(':root'));

	return props.children ? (
		<>
			<div
				className='sf-toaster-w body-text-2'
				style={{
					borderTop:
						'1px solid' + styleVars.getPropertyValue('--srvMsgColor') + '33',
				}}
			>
				{props.children}
			</div>
		</>
	) : null;
}
export { Toaster };
